import Loadable from "react-loadable";

export const AddPostButton = Loadable({
  loader: () => import("../../../../modules/manage-posts").then((module) => module.AddPostButton) as Promise<any>,
  loading: () => null,
});
